import { orderDeliveryTypes } from '../constants/order.constant';

// Platform enum on the API: Kiosk = 0, Website = 10, Mobile = 20.
// The online ordering site is always Website.
export const WEBSITE_PLATFORM = 10;

// Single source of truth for the ordertype fallback. The basket initializes
// deliveryType to orderDeliveryTypes[0] (Pick up), so keep the fallback in
// sync with that instead of hardcoding divergent defaults per call site.
export const getOrderTypeValue = (deliveryType) =>
  deliveryType?.value ?? orderDeliveryTypes[0].value;

// One basket line -> wire item. Wire contract (multi-qty modifiers):
// options[].qty is the TOTAL units of that modifier across the line —
// unit qty x line qty. Client state stores the UNIT count; legacy
// localStorage carts have no qty field and count 1. Exactly one options[]
// entry per distinct optionid (state keeps one row per option).
export const buildOrderItemPayload = (item) => ({
  itemid: item.item.id,
  qty: item.qty,
  options: (item.options || []).map((option) => ({
    optionid: option.id,
    qty: (option.qty ?? 1) * item.qty,
  })),
});

// Shared payload for Discount/CalculateForCustomer. platform + ordertype are
// REQUIRED: the API's extra-fee gate matches both against each fee's allowed
// lists, and the model defaults them to 0 when omitted — which silently drops
// every extra fee and makes the checkout total disagree with the charged
// order total.
export const buildCalculateBasketPayload = (basket, storeid) => ({
  items: (basket.items || []).map(buildOrderItemPayload),
  discountcode: basket.discountcode,
  tip: basket.tip || 0,
  tiprate: basket.tiprate || 0,
  storeid,
  platform: WEBSITE_PLATFORM,
  ordertype: getOrderTypeValue(basket.deliveryType),
});
